import React from "react";
import Iframe from "react-iframe";

const PodCast = props => {
  return (
    <div className="podCast staticSection">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4">
            <h4>Subscribe to the podcast</h4>
            <p>
              Close your business day with the ausbiz anchors and a wrap of the
              day's key stories
            </p>
            <a
              href="https://play.acast.com/s/the-call"
              className="btn moreEpisodeBtn noDisplayMobile"
              target="_blank"
            >
              MORE EPISODES
            </a>
          </div>
          <div className="col-md-8">
            <Iframe
              src="https://share.transistor.fm/e/final-squawk/latest/dark"
              width="100%"
              height="180"
              frameBorder="0"
              scrolling="no"
              styles={{ border: "0" }}
            />
          </div>
          <div className="col-12 displayMobile marTop20">
            <a
              href="https://play.acast.com/s/the-call"
              className="btn moreEpisodeBtn displayMobile"
              target="_blank"
            >
              MORE EPISODES
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PodCast;
